module.exports = __webpack_public_path__ + "img/objetos-13.22393f97.png";